import { Box, SxProps, Theme } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"

const ASAAS_SEAL_ENABLED =
  process.env.REACT_APP_ASAAS_SEAL_ENABLED !== "false"

const ASAAS_SEAL_URL =
  process.env.REACT_APP_ASAAS_SEAL_URL ||
  "/assets/asaas/selo-servicos-financeiros.svg"

const ASAAS_SEAL_LINK =
  process.env.REACT_APP_ASAAS_SEAL_LINK || "https://asaas.com"

interface IAsaasSealProps {
  sx?: SxProps<Theme>
}

const AsaasSeal = ({ sx }: IAsaasSealProps) => {
  const { t } = useTranslation()

  if (!ASAAS_SEAL_ENABLED) return null

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 1,
        ...sx,
      }}
    >
      <a
        href={ASAAS_SEAL_LINK}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "inline-block", lineHeight: 0 }}
      >
        <img
          src={ASAAS_SEAL_URL}
          alt={t("asaas.sealAlt")}
          width="160"
          height="48"
          style={{ display: "inline-block" }}
        />
      </a>
    </Box>
  )
}

export default AsaasSeal
